<script lang="ts" setup>
import MarginManagement from "@/data-views/tables/pricelist/MarginManagement.vue";
import { loader } from "@/components/loader/loader";

definePage({
  meta: {
    action: "read",
    subject: "PriceConfiguration",
    navActiveLink: "pricelist-margin-management",
  },
});

const loading = ref(false);

onMounted(() => {
  loading.value = true;
  setTimeout(() => {
    loading.value = false;
    loader.stop();
  }, 500);
});
</script>

<template>
  <VRow class="match-height">
    <VCol cols="12">
      <MarginManagement v-if="!loading" :show-worst-rows="false" />
      <div v-else style="min-height: 50vh" />
    </VCol>
  </VRow>
</template>

